import * as R from 'ramda';

const refreshInstagramAccounts = () => async (state, newInstagramAccounts) => {
    const userClientId = state.user.selectedUserClientId;

    return R.assocPath(
        ['clients', userClientId, 'socialAccounts', 'instagram', 'accounts'],
        newInstagramAccounts,
        state,
    );
};

export default refreshInstagramAccounts;
